import * as moment from "moment-timezone";
import {MomentAdapter} from "./moment.utils";
import {GroupFieldsModel} from "../../modules/common/group-fields/group-fields.model";
import {
    AmountFieldModel,
    DateFieldModel,
    DateTimeFieldModel,
    FieldModel,
    MultipleChoiceFieldModel,
    NumericFieldModel,
    SingleChoiceFieldModel,
    TextFieldModel,
    YesNoFieldModel
} from "../../modules/common/group-fields/field/field.model";
import {FormDefinitionFormModel} from "../../modules/form/definition/form/api/entity/formDefinitionForm.model";

export class RandomUtils {

    public static randomNumber(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    public static randomTown() {
        let number = RandomUtils.randomNumber(0,4);
        switch (number) {
            case 0 : return "Namur";
            case 1 : return "Ciney";
            case 2 : return "Hamois";
            case 3 : return "Schaltin";
            case 4 : return "Florée";
        }
    }

    public static randomString(length) {
        let result           = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
        for ( let i = 0; i < length; i++ ) {
            result += characters.charAt(Math.floor(Math.random() * characters.length));
        }
        return result;
    }

    public static randomDate():moment.Moment {
        return MomentAdapter.current().addHours(RandomUtils.randomNumber(1,4)).addDays(RandomUtils.randomNumber(1,3)).get();
    }

    public static randomBoolean() {
        return RandomUtils.randomNumber(0,1) === 1;
    }

    public static randomColor() {
        let letters = '0123456789ABCDEF';
        let color = '#';
        for (let i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    }

    public static randomDynamicFormModel(): FormDefinitionFormModel {
        return undefined;
        /* return {
            id :this.randomNumber(0, 1000),
            lovValue: {
                parentLabel: undefined,
                lovList: undefined,
                id: undefined,
                permissions: undefined,
                param: undefined,
                comment: undefined,
                label: 'Formulaire n°' + this.randomNumber(0, 100),
                value: 'Formulaire n°' + this.randomNumber(0, 100),
            },
            groups : [
                this.randomCreateGroup('group0'),
                this.randomCreateGroup('group1'),
                // this.randomCreateGroup('group2'),
                // this.randomCreateGroup('group3'),
                // this.randomCreateGroup('group4'),
            ],
            permissions : {
                deletable : true,
                updatable : true,
            }
        }; */
    }

    public static randomCreateGroup(name?:string):GroupFieldsModel {
        return {
            name : name? name : this.randomString(5),
            label : this.randomString(5),
            fields : [
                this.randomCreateTextField(),
                this.randomCreateNumericField(),
                this.randomCreateNumericFieldMandatory(),
                this.randomCreateSingleChoiceFieldModel(),
                this.randomCreateMultipleChoiceField(),
                this.randomCreateSingleChoiceFieldModelAsList(),
                this.randomCreateMultipleChoiceFieldAsList(),
                this.randomCreateAmountFieldModel(),
                this.randomCreateDateField(),
                this.randomCreateDateTimeField(),
                this.randomCreateYesNoFieldModel(),
            ],
        };
    }

    private static randomCreateTextField():FieldModel<string> {
        return new TextFieldModel('name1', 'Text field (mandatory)', true, 'Text value');
    }


    private static randomCreateNumericFieldMandatory():FieldModel<number> {
        return new NumericFieldModel('name2', 'Numeric field (mandatory)', 0, false, true, 10);
    }


    private static randomCreateAmountFieldModel():FieldModel<number> {
        return new AmountFieldModel('name5', 'Amount field (mandatory)', 2, false, true, 200.22);
    }

    private static randomCreateSingleChoiceFieldModel():FieldModel<number> {
        let singleFieldChoice : SingleChoiceFieldModel<number> = new SingleChoiceFieldModel('name3', 'Single choice field', false, false);
        singleFieldChoice.value = 3;
        singleFieldChoice.allValues = [1,2,3,4,5];
        return singleFieldChoice;
    }


    private static randomCreateMultipleChoiceField():FieldModel<number[]> {
        let multipleChoiceFieldModel : MultipleChoiceFieldModel<number> = new MultipleChoiceFieldModel('name4', 'Multiple choice field (mandatory)', false, true);
        multipleChoiceFieldModel.value = [3,5];
        multipleChoiceFieldModel.allValues = [1,2,3,4,5];
        return multipleChoiceFieldModel;
    }

    private static randomCreateNumericField():FieldModel<number> {
        return new NumericFieldModel('name6', 'Numeric field (accept negative)', 0, true, false, 5);
    }

    private static randomCreateDateField():FieldModel<moment.Moment> {
        return new DateFieldModel('name7', 'Date field (mandatory)', true, MomentAdapter.current().get());
    }

    private static randomCreateDateTimeField():FieldModel<moment.Moment> {
        return new DateTimeFieldModel('name8', 'Datetime field', false, MomentAdapter.current().addDays(8).get());
    }

    private static randomCreateYesNoFieldModel():FieldModel<boolean> {
        return new YesNoFieldModel('name9', 'YesNo field (mandatory) with default value', true, undefined, false);
    }

    private static randomCreateSingleChoiceFieldModelAsList():FieldModel<number> {
        let singleFieldChoice : SingleChoiceFieldModel<number> = new SingleChoiceFieldModel('name10', 'Single choice field (display on list)', true, false);
        singleFieldChoice.value = 3;
        singleFieldChoice.allValues = [1,2,3,4,5];
        return singleFieldChoice;
    }


    private static randomCreateMultipleChoiceFieldAsList():FieldModel<number[]> {
        let multipleChoiceFieldModel : MultipleChoiceFieldModel<number> = new MultipleChoiceFieldModel('name11', 'Multiple choice field (mandatory) (display on list)', true, true);
        multipleChoiceFieldModel.value = [3,5];
        multipleChoiceFieldModel.allValues = [1,2,3,4,5];
        return multipleChoiceFieldModel;
    }
}